import React, {Component} from 'react';
import './Form.css';

class Form extends Component {
	constructor() {
		super();

		this.handleKeyPress = e => {
			if (e.key === 'Enter') {
				e.preventDefault(); // Prevent default form submission
			}
		};
	}

	render() {
		return (
			<form className={`Form ${this.props.className || ''}`} onKeyPress={this.handleKeyPress}>
				{this.props.children}
			</form>
		);
	}
}

export default Form;



// WEBPACK FOOTER //
// ./src/widgets/Form.js